export const EventTemplateOptionTypes = ['static text', 'text', 'dropdown', 'checkboxes', 'radio buttons']
